import { PAGE_KEY } from './constants';
import type { TPTTranslations } from './types';

export const pt: TPTTranslations = {
  [PAGE_KEY]: {
    PAGE_TITLE: 'Comunidade',
    PAGE_DESCRIPTION:
      'Fostera a comunicação e o sentido de comunidade na sua empresa com um canal onde você pode publicar conteúdos de interesse.',

    GLOBAL_CANCEL: 'Cancelar',
    GLOBAL_ERROR_MESSAGE:
      'Não foi possível executar a ação. Por favor, tente novamente.',

    CHANNEL_INFO_ERROR_TITLE: 'Ocorreu um erro',
    CHANNEL_INFO_ERROR_DESCRIPTION:
      'Ocorreu um erro ao carregar a informação do canal.',

    PAGE_BREADCRUMB_COMMUNITY: 'Comunidade',
    PAGE_BREADCRUMB_HOME: 'Inicio',
    PAGE_BREADCRUMB_CONNECTION: 'Conexão',
    PAGE_BREADCRUMB_CHANNELS: 'Meus canais',

    BANNER_PUBLIC_LABEL: 'Público',
    BANNER_PUBLIC_TOOLTIP: 'Toda a empresa pode ver as publicações.',
    BANNER_PRIVATE_LABEL: 'Privado',
    BANNER_PRIVATE_TOOLTIP:
      'Somente os administradores podem ver as publicações.',

    TABS_FEED_LABEL: 'Muro',
    TABS_INFORMATION_LABEL: 'Informação',
    TABS_SCHEDULED_LABEL: 'Programadas',
    CONFIGURATION_BUTTON_LABEL: 'Configuração',
    ADMIN_EDIT_PERMISSION_REQUIRED_TOOLTIP:
      'Você não tem permissão para realizar esta ação.',

    CHANNEL_INFORMATION_TITLE: 'Informação do canal',
    CHANNEL_INFORMATION_NAME: 'Nome do canal',
    CHANNEL_INFORMATION_DESCRIPTION: 'Descrição',
    CHANNEL_INFORMATION_PERMISSIONS: 'Permissões',
    CHANNEL_INFORMATION_PUBLIC: 'Canal público.',
    CHANNEL_INFORMATION_PRIVATE: 'Canal privado.',
    CHANNEL_INFORMATION_ADMIN_PUBLISH:
      'Somente os administradores podem publicar.',
    CHANNEL_INFORMATION_DESCRIPTION_CONTENT:
      'Bem-vindo ao espaço onde compartilharemos anúncios com toda a empresa.',

    // Post interactions
    POST_VIEW_COMMENTS: 'Ver {{count}} comentário',
    POST_VIEW_COMMENTS_plural: 'Ver os {{count}} comentários',
    POST_VIEW_HIDE_COMMENTS: 'Ocultar comentários',
    POST_REACT_BUTTON: 'Reagir',
    POST_COMMENT_BUTTON: 'Comentar',
    POST_VIEW_CREATED_AT: 'Criado: {{date}}',
    POST_VIEW_SHOW_MORE: 'Ver mais',
    POST_VIEW_SHOW_LESS: 'Ver menos',
    POST_VIEW_UPDATED_AT: 'Editado: {{date}}',

    // Error view
    ERROR_TITLE: 'Ocorreu um erro',
    ERROR_DESCRIPTION: 'Clique no botão para tentar carregar novamente.',
    ERROR_RETRY_BUTTON: 'Tentar novamente',

    // Empty view
    EMPTY_TITLE: 'Ainda não há publicações neste muro',
    EMPTY_DESCRIPTION:
      'Faça a primeira publicação para gerar interações entre os seus colaboradores.',
    EMPTY_DESCRIPTION_END_USER:
      'Em breve você saberá as notícias da sua empresa.',
    EMPTY_CREATE_BUTTON: 'Criar publicação',
    EMPTY_NO_POSTS_ALT: 'Sem publicações',

    COMMENT_INPUT_PLACEHOLDER:
      'Escreva um comentário e/ou use @ para mencionar alguém',
    COMMENT_INPUT_BUTTON: 'Comentar',

    // @mention autosuggest (shared by post + comment editors)
    MENTION_EMPTY_LABEL: 'Nenhuma pessoa encontrada com esse nome.',
    MENTION_LOADING_LABEL: 'Buscando pessoas…',
    MENTION_ERROR_LABEL:
      'Não foi possível carregar a lista de menções. Tente recarregar.',

    // Warning dialog shown before publishing/commenting in a private channel
    // when a tagged user is neither a member nor part of the channel's
    // segmentation (RN-002 / VAL-002).
    MENTION_WARNING_TITLE:
      'Alguns colaboradores marcados não são membros deste canal ou não atendem à segmentação necessária para pertencer a ele.',
    MENTION_WARNING_DESCRIPTION:
      'Por esse motivo, não poderão ver a publicação nem receber notificações das menções.',

    // User detail drawer opened when a mention chip is clicked
    MENTION_DRAWER_TITLE: 'Detalhe do usuário',
    MENTION_DRAWER_MEMBER_BADGE: 'Membro do canal',
    MENTION_DRAWER_OUTSIDE_BADGE: 'Fora do canal',
    MENTION_DRAWER_MEMBER_NOTE:
      '{{name}} é membro deste canal. Se você o mencionar, receberá o e-mail de menções no dia seguinte.',
    MENTION_DRAWER_OUTSIDE_NOTE:
      '{{name}} não é membro deste canal. A menção ficará visível, mas não receberá o e-mail de menções.',
    MENTION_DRAWER_CLOSE: 'Fechar',
    MENTION_DRAWER_TAB_INFO: 'Informação',
    MENTION_DRAWER_TAB_LEARNING: 'Aprendizagem',
    MENTION_DRAWER_ABOUT_ME: 'Sobre mim',
    MENTION_DRAWER_SITE: 'Sede',
    MENTION_DRAWER_CITY: 'Cidade',
    MENTION_DRAWER_COUNTRY: 'País',
    MENTION_DRAWER_GENDER: 'Gênero',
    MENTION_DRAWER_BIRTHDAY: 'Aniversário',
    MENTION_DRAWER_PHONE: 'Telefone',
    MENTION_DRAWER_GENDER_MALE: 'Masculino',
    MENTION_DRAWER_GENDER_FEMALE: 'Feminino',
    MENTION_DRAWER_GENDER_OTHER: 'Outro',
    MENTION_DRAWER_STATUS_ACTIVE: 'Ativo',
    MENTION_DRAWER_STATUS_PENDING: 'Pendente',
    MENTION_DRAWER_STATUS_INACTIVE: 'Inativo',
    MENTION_DRAWER_STATUS_DELETED: 'Excluído',
    MENTION_DRAWER_USER_TYPE_USER: 'Usuário',
    MENTION_DRAWER_USER_TYPE_ADMIN: 'Administrador',
    MENTION_DRAWER_USER_TYPE_SUBADMIN: 'Subadmin',
    MENTION_DRAWER_USER_TYPE_LEADER: 'Líder',
    MENTION_DRAWER_BACK: 'Voltar',
    MENTION_DRAWER_VIEW_PROFILE: 'Ver perfil',
    MENTION_DRAWER_RETRY: 'Tentar novamente',
    MENTION_DRAWER_LEARNING_EMPTY:
      'Não há informações de aprendizagem disponíveis.',
    MENTION_DRAWER_ERROR: 'Não foi possível carregar o detalhe do usuário.',

    // Aba Aprendizagem (Cursos / Rotas) — paridade com o organograma
    TABS_LEARNING_COURSES: 'Cursos',
    TABS_LEARNING_TRACKS: 'Rotas',
    TABS_LEARNING_PROGRESS_TRACK_TAG: 'Rota de aprendizagem',
    TABS_LEARNING_COURSE_TOOLTIP_OWN: 'Curso próprio',
    TABS_LEARNING_COURSE_TOOLTIP_CREHANA: 'Curso Crehana',
    TABS_LEARNING_PROGRESS_INFO_1: '{{amount}}% de progresso',
    TABS_LEARNING_PROGRESS_INFO_2: '{{amount}} cursos obrigatórios',
    TABS_LEARNING_PROGRESS_TOTAL: 'PROGRESSO TOTAL',
    TABS_LEARNING_PROGRESS_TOTAL_TOOLTIP:
      'Indica a porcentagem de progresso em\nrelação ao total de cursos atribuídos',
    TABS_LEARNING_PROGRESS_TOTAL_TOOLTIP_TRACK:
      'Indica a porcentagem de progresso em\nrelação ao total de rotas atribuídas',
    TABS_LEARNING_COURSES_EMPTY: 'O usuário não tem cursos atribuídos.',
    TABS_LEARNING_TRACKS_EMPTY: 'O usuário não tem rotas atribuídas.',
    TABS_LEARNING_ERROR:
      'Não foi possível carregar a atividade de aprendizagem.',
    TABS_LEARNING_PAGINATION_PREV: 'Anterior',
    TABS_LEARNING_PAGINATION_NEXT: 'Próximo',
    MENTION_DRAWER_EMPTY_VALUE: '-',
    COMMENT_SUCCESS_MESSAGE: 'Comentário publicado com sucesso.',
    COMMENT_INPUT_REQUIRED_ERROR: 'O comentário é obrigatório',
    COMMENT_INPUT_MAX_LENGTH_ERROR:
      'O comentário deve ter menos de 500 caracteres',
    COMMENT_OFFENSIVE_WORDS_ERROR_MESSAGE:
      'O comentário contém palavras que não são permitidas: {{words}}.',
    POST_OFFENSIVE_WORDS_ERROR_MESSAGE:
      'O conteúdo tem palavras que não são permitidas: {{words}}.',

    COMMENT_UPLOAD_IMAGE_BUTTON_LABEL: 'Enviar imagem',
    COMMENT_UPLOAD_IMAGE_FORMAT_LABEL: 'Tamanho e formatos',
    COMMENT_UPLOAD_IMAGE_TOOLTIP:
      'Formato: JPG, PNG ou GIF.\nTamanho máximo: 5 MB.',
    COMMENT_IMAGE_ALT_FALLBACK: 'Imagem anexada por {{author}}',
    COMMENT_IMAGE_CLOSE_PREVIEW: 'Fechar visualização da imagem',

    COMMENT_LIKE_BUTTON: 'Curtir',
    SHOW_MORE_COMMENTS: 'Ver mais comentários',

    POST_EDIT_COMMENT_BUTTON: 'Editar',
    COMMENT_EDIT_SAVE_BUTTON: 'Salvar alterações',
    COMMENT_EDIT_CANCEL_BUTTON: 'Cancelar',
    POST_DELETE_COMMENT_BUTTON: 'Deletar',

    POST_REACTION_LIKE: 'Curtir',
    POST_REACTION_LOVE: 'Amar',
    POST_REACTION_INTERESTED: 'Gostei',

    DELETE_COMMENT_TITLE_OWN: 'Deseja deletar seu comentário?',
    DELETE_COMMENT_TITLE_OTHER: 'Deseja deletar o comentário de {{userName}}?',
    DELETE_COMMENT_SUBTITLE: 'Ao confirmar, não poderás reverter esta ação.',
    DELETE_COMMENT_CTA_CANCEL: 'Cancelar',
    DELETE_COMMENT_CTA_CONFIRM: 'Sim, deletar',

    POSTS_FEED_RECENT_POSTS: 'Ver publicações recentes',
    POSTS_FEED_NEW_POSTS: 'Há novas publicações',

    REACTION_TABLE_USER_HEADER: 'Nome',

    // Channels view
    CHANNELS_VIEW_TRIGGER_BUTTON: 'Ver canais',
    CHANNELS_VIEW_TITLE: 'Canais',
    CHANNELS_VIEW_CHANNEL_SEARCH_PLACEHOLDER: 'Buscar canal',
    CHANNELS_VIEW_CHANNEL_CREATE_BUTTON: 'Criar canal',
    CHANNELS_VIEW_CHANNEL_DISCOVER_BUTTON: 'Descobrir canais',
    CHANNELS_VIEW_CHANNEL_MAIN_CHANNEL: 'Principal',
    CHANNELS_VIEW_CHANNEL_OTHER_CHANNELS: 'Mais canais',
    CHANNELS_VIEW_CHANNEL_OTHER_CHANNELS_END_USER: 'Você é membro de',
    CHANNELS_VIEW_ERROR_TITLE: 'Ocorreu um erro',
    CHANNELS_VIEW_ERROR_DESCRIPTION:
      'Clique no botão para tentar carregar novamente.',
    CHANNELS_VIEW_EMPTY_TITLE: 'Não foram encontrados resultados para',
    CHANNELS_VIEW_EMPTY_DESCRIPTION: 'Tente novamente com um termo diferente.',

    // Leave Channel
    LEAVE_CHANNEL_BUTTON: 'Abandonar canal',
    LEAVE_CHANNEL_TITLE: 'Deseja abandonar o canal {{name}}?',
    LEAVE_CHANNEL_DESCRIPTION:
      'Seus mensagens permanecerão visíveis no canal até que um administrador as remova. Você pode voltar a participar se ainda tiver os permissões necessárias para acessar o canal.',
    LEAVE_CHANNEL_CTA: 'Sim, abandonar',
    CHANNEL_LEAVE_SUCCESS: 'Você abandonou o canal {{name}} com sucesso.',
    CHANNEL_LEAVE_SUCCESS_DESCRIPTION:
      'Você pode voltar a participar se ainda tiver os permissões necessárias para acessar o canal.',

    UPLOAD_FILE_INPUT_BUTTON_LABEL: 'Carregar imagem',
    UPLOAD_FILE_INPUT_LABEL_DESCRIPTION:
      'Formato: JPG, PNG, GIF, MP4 ou MOV. Tamanho: 1280 x 720 px. Máx: 5 MB imagem e 1 GB vídeo.',
    UPLOAD_FILE_INPUT_FORMAT_LABEL: 'Pesos e formatos',

    CONFIRM_DIALOG_TITLE: 'Deseja sair e descartar a publicação?',
    CONFIRM_DIALOG_TITLE_EDIT: 'Deseja sair sem salvar as alterações?',
    CONFIRM_DIALOG_DESCRIPTION:
      'As informações que você inseriu serão perdidas.',
    CONFIRM_DIALOG_DESCRIPTION_EDIT:
      'As modificações que você realizou serão perdidas.',
    CONFIRM_DIALOG_CANCEL_TEXT: 'Cancelar',
    CONFIRM_DIALOG_CONFIRM_TEXT: 'Sim, sair',

    CREATE_NEW_POST_INPUT_BUTTON_LABEL: 'O que você quer comunicar hoje?',
    CREATE_NEW_POST_INPUT_TITLE: 'Criar publicação',
    CREATE_NEW_POST_INPUT_TITLE_EDIT: 'Editar publicação',
    CREATE_NEW_POST_INPUT_DESCRIPTION:
      'Escreva uma mensagem para sua comunidade. Você pode adicionar imagens, vídeos e links.',
    CREATE_NEW_POST_INPUT_CONFIRM_BUTTON_LABEL: 'Publicar',
    CREATE_NEW_POST_INPUT_SCHEDULE_BUTTON_LABEL: 'Programar',
    CREATE_NEW_POST_INPUT_SAVE_BUTTON_LABEL: 'Salvar',
    CREATE_NEW_POST_INPUT_PUBLISH_NOW_BUTTON_LABEL: 'Publicar agora',
    CREATE_NEW_POST_INPUT_PLACEHOLDER:
      'Escreva uma publicação e/ou use @ para mencionar alguém',
    CREATE_NEW_POST_INPUT_REACH_LABEL: 'Alcance: {{count}} pessoa',
    CREATE_NEW_POST_INPUT_REACH_LABEL_plural: 'Alcance: {{count}} pessoas',

    CREATE_NEW_POST_INPUT_SUCCESS_MESSAGE: 'Mensagem publicada com sucesso.',
    CREATE_NEW_POST_INPUT_SCHEDULED_SUCCESS_MESSAGE:
      'Publicação agendada com sucesso.',
    UPDATE_POST_INPUT_SUCCESS_MESSAGE: 'Alterações salvas com sucesso.',
    DELETE_POST_INPUT_SUCCESS_MESSAGE: 'A publicação foi excluída com sucesso.',

    POST_DELETE_TITLE: 'Deseja excluir a publicação?',
    POST_DELETE_BUTTON: 'Excluir',
    POST_EDIT_BUTTON: 'Editar',
    // [TODO: PM/translator confirm] — placeholder translations from technical plan
    POST_SHARE_LINK_BUTTON: 'Compartilhar link',
    POST_SHARE_LINK_SUCCESS_TITLE:
      'O link foi copiado para a área de transferência',
    POST_SHARE_LINK_ERROR_TITLE: 'Erro ao gerar o link',
    POST_SHARE_LINK_ERROR_DESCRIPTION:
      'Não foi possível gerar o link. Por favor, tente novamente.',
    POST_DELETE_DESCRIPTION:
      'Esta ação é irreversível. Se a publicação tiver comentários, eles também serão excluídos permanentemente.',
    POST_DELETE_CONFIRM_BUTTON: 'Sim, excluir',
    POST_DELETE_SUCCESS_MESSAGE: 'A publicação foi excluída com sucesso.',

    // Edit Channel
    EDIT_CHANNEL_BUTTON: 'Editar configuração',

    // Moderators selector
    STEP_3_ASSIGNED_USERS_TITLE: 'Usuários atribuídos',
    STEP_3_ASSIGNED_USERS_PLACEHOLDER: 'Selecionar usuários',
    STEP_3_ASSIGNED_USERS_SEARCH_PLACEHOLDER: 'Buscar',
    STEP_3_ASSIGNED_USERS_EMPTY: 'Não há usuários disponíveis.',
    STEP_3_ASSIGNED_USERS_REMOVE_LABEL: 'Remover usuário',
    STEP_3_MODERATORS_LIMIT_REACHED:
      'Você atingiu o limite de 100 moderadores.',

    // Delete Channel
    DELETE_CHANNEL_BUTTON: 'Deletar',
    DELETE_CHANNEL_TITLE: 'Deseja deletar o canal {{name}}?',
    DELETE_CHANNEL_DESCRIPTION:
      'Esta ação é irreversível e você perderá todas as publicações, comentários e métricas. Escreva “DELETAR” para confirmar a ação.',
    DELETE_CHANNEL_CONFIRMATION: 'DELETAR',
    DELETE_CHANNEL_CTA: 'Sim, deletar',
    CHANNEL_DELETE_SUCCESS: 'A deleção foi realizada com sucesso.',
    CHANNEL_DELETE_SUCCESS_DESCRIPTION:
      'Lembre-se de que não poderás reverter esta ação.',
    CHANNEL_DELETE_ERROR: 'Não foi possível completar a deleção ',
    CHANNEL_DELETE_ERROR_DESCRIPTION: 'Por favor, tente novamente mais tarde.',

    // Convert to main channel
    CONVERT_TO_MAIN_CHANNEL_BUTTON: 'Converter em canal principal',
    CONVERT_TO_MAIN_CHANNEL_TITLE: 'Deseja converter este canal em principal?',
    CONVERT_TO_MAIN_CHANNEL_DESCRIPTION:
      'Antes de confirmar, considere estas considerações sobre o canal principal:',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_1:
      'O canal principal é o que primeiro aparece ao entrar em “Comunidade”.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_2:
      'Você não poderá editar a configuração de “Permissões para entrar”, pois o canal principal deve sempre ser público, incluir automaticamente todos os membros da empresa e não pode ser abandonado.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_3:
      'Se este canal tiver usuários que o abandonaram, eles serão reincorporados automaticamente ao estabelecer como principal.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_4:
      'Você não poderá excluir o canal principal até designar outro em seu lugar.',
    CONVERT_TO_MAIN_CHANNEL_CONFIRMATION:
      'Confirmo que entendo as implicações e quero continuar com a alteração.',
    CONVERT_TO_MAIN_CHANNEL_CTA: 'Sim, converter',
    CHANNEL_CONVERT_TO_MAIN_SUCCESS:
      'O canal foi estabelecido como canal principal com sucesso.',
    CHANNEL_CONVERT_TO_MAIN_SUCCESS_DESCRIPTION:
      'Todos os usuários ativos e pendentes vão se juntar automaticamente a este canal.',

    // Upload image or video dialog
    UPLOAD_IMAGE_OR_VIDEO_BUTTON_LABEL: 'Imagem ou vídeo',
    UPLOAD_IMAGE_BUTTON_ARIA_LABEL: 'Carregar imagem',
    UPLOAD_VIDEO_BUTTON_ARIA_LABEL: 'Carregar vídeo',
    UPLOAD_IMAGE_OR_VIDEO_DIALOG_TITLE: 'Carregar imagem ou vídeo',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_LABEL:
      'Descrição alternativa para acessibilidade',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_DESCRIPTION:
      'Os leitores de tela leem isso para pessoas com deficiência visual.',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_PLACEHOLDER: 'Descrição breve da imagem',
    UPLOAD_VIDEO_ALT_TEXT_PLACEHOLDER: 'Descrição breve do vídeo',
    MULTI_IMAGE_HEADER_LABEL: 'Imagens',
    MULTI_IMAGE_REORDER_HINT: 'Arraste as miniaturas para reordenar.',
    MULTI_IMAGE_ADD_MORE_ARIA_LABEL: 'Adicionar mais imagens',
    MULTI_IMAGE_DELETE_ARIA_LABEL: 'Excluir imagem',
    DELETE_BUTTON_TOOLTIP: 'Excluir',
    MULTI_IMAGE_MAX_REACHED_ERROR: 'Você atingiu o máximo de {{max}} imagens.',
    MULTI_IMAGE_LIMIT_REACHED_TOOLTIP:
      'Você atingiu o limite de {{max}} imagens por publicação.',
    MULTI_IMAGE_DELETE_CONFIRM_TITLE: 'Deseja remover a imagem?',
    MULTI_IMAGE_DELETE_CONFIRM_DESCRIPTION:
      'Esta ação não pode ser desfeita. A imagem será removida da publicação.',
    MULTI_IMAGE_DELETE_CONFIRM_BUTTON: 'Sim, remover',
    MULTI_IMAGE_DELETE_SUCCESS: 'Imagem excluída com sucesso.',
    IMAGE_SIZE_EXCEEDED_ERROR_TITLE:
      '{{count}} arquivo(s) excedem o limite de tamanho permitido.',
    IMAGE_SIZE_EXCEEDED_ERROR_DESCRIPTION:
      'O tamanho máximo por imagem é de 5 MB.',
    MULTI_IMAGE_UPLOADING_LABEL: 'Enviando arquivo',
    MULTI_IMAGE_CANCEL_UPLOAD_ARIA_LABEL: 'Cancelar envio',
    UPLOAD_IMAGE_OR_VIDEO_DIALOG_SUBMIT_BUTTON: 'Inserir',
    ALTERNATIVE_TEXT_ERROR_MESSAGE:
      'Apenas letras, números, espaços, hífens, parênteses, pontos e vírgulas são permitidos.',

    CREATE_NEW_POST_INPUT_NOTIFY_LABEL: 'Notificar',
    CREATE_NEW_POST_INPUT_NOTIFY_TOOLTIP:
      'Ative a opção se desejar notificar esta publicação ao seu público por e-mail.',
    SCHEDULE_FOR_LATER_LABEL: 'Programar para mais tarde',
    SCHEDULE_FOR_LATER_DESCRIPTION:
      'Defina uma data e hora para que a publicação seja publicada automaticamente.',
    SCHEDULE_DATE_LABEL: 'Data',
    SCHEDULE_DATE_PLACEHOLDER: 'Selecione uma data',
    SCHEDULE_TIME_LABEL: 'Hora',
    SCHEDULE_TIME_PLACEHOLDER: 'Selecionar hora',
    SCHEDULE_TIMEZONE_LABEL: 'Fuso horário',
    SCHEDULED_EMPTY_TITLE: 'Ainda não há publicações programadas',
    SCHEDULED_EMPTY_DESCRIPTION:
      'Aqui serão exibidas as mensagens que serão publicadas em uma data e hora futuras.',
    SCHEDULED_CREATE_BUTTON: 'Criar publicação',
    SCHEDULED_TABLE_DESCRIPTION:
      'Os administradores e moderadores visualizam todas as publicações do canal.',
    SCHEDULED_SEARCH_PLACEHOLDER: 'Buscar',
    SCHEDULED_COLUMN_POST: 'Publicação programada',
    SCHEDULED_COLUMN_PRE_CREATION_DATE: 'Data de pré-criação',
    SCHEDULED_COLUMN_SCHEDULED_DATE: 'Data programada',
    SCHEDULED_COLUMN_ACTIONS: 'Ações',
    SCHEDULED_PRE_CREATION_TOOLTIP:
      'Esta data não aparecerá na mensagem quando publicada, mas o autor original sim.',
    SCHEDULED_USER_DEACTIVATED_TOOLTIP:
      'Usuário excluído ou desativado da plataforma',
    SCHEDULED_ACTION_OPEN_ACTIONS: 'Abrir ações da publicação',
    SCHEDULED_ACTION_PREVIEW: 'Pré-visualização',
    SCHEDULED_ACTION_EDIT: 'Editar',
    SCHEDULED_ACTION_HISTORY: 'Ver histórico de alterações',
    SCHEDULED_ACTION_PUBLISH_NOW: 'Publicar agora',
    SCHEDULED_ACTION_DELETE: 'Excluir',
    SCHEDULED_SEARCH_EMPTY_TITLE: 'Não foram encontrados resultados para',
    SCHEDULED_SEARCH_EMPTY_DESCRIPTION:
      'Tente novamente com um termo diferente.',
    SCHEDULED_SORT_NEWEST: 'Mais recentes',
    SCHEDULED_SORT_OLDEST: 'Mais antigas',
    SCHEDULED_BY_AUTHOR: 'Por: {{name}}',
    SCHEDULED_AT_CONNECTOR: 'à(s)',
    SCHEDULED_BULK_DELETE_TOOLTIP: 'Excluir',
    SCHEDULED_PUBLISH_NOW_DIALOG_TITLE: 'Deseja publicar a mensagem agora?',
    SCHEDULED_PUBLISH_NOW_DIALOG_DESCRIPTION:
      'A mensagem deixará de estar programada e será exibida imediatamente no muro do canal.',
    SCHEDULED_PUBLISH_NOW_DIALOG_CONFIRM: 'Sim, publicar',
    SCHEDULED_PUBLISH_NOW_SUCCESS: 'Mensagem publicada com sucesso.',
    SCHEDULED_DELETE_DIALOG_TITLE: 'Deseja excluir a publicação?',
    SCHEDULED_DELETE_DIALOG_DESCRIPTION:
      'Esta ação é irreversível e você perderá o conteúdo da publicação.',
    SCHEDULED_DELETE_DIALOG_CONFIRM: 'Sim, excluir',
    SCHEDULED_DELETE_SUCCESS: 'A exclusão foi realizada com sucesso.',
    SCHEDULED_DELETE_SUCCESS_DESCRIPTION:
      'Lembre-se de que não será possível reverter esta ação.',
    SCHEDULED_DELETE_ERROR: 'Não foi possível completar a exclusão',
    SCHEDULED_DELETE_ERROR_DESCRIPTION:
      'Por favor, tente novamente mais tarde.',
    SCHEDULED_BULK_DELETE_DIALOG_TITLE: 'Deseja excluir {{count}} publicação?',
    SCHEDULED_BULK_DELETE_DIALOG_TITLE_MULTIPLE:
      'Deseja excluir {{count}} publicações?',
    SCHEDULED_BULK_DELETE_DIALOG_DESCRIPTION:
      'Esta ação é irreversível e você perderá o conteúdo das mensagens. Escreva "EXCLUIR" para confirmar a ação.',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRMATION: 'EXCLUIR',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRM: 'Sim, excluir',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRM_INPUT_LABEL:
      'Digite {{word}} para confirmar a exclusão',
    SCHEDULE_TIME_INVALID: 'Hora inválida, selecione um horário no futuro.',
    SCHEDULED_PREVIEW_DIALOG_TITLE: 'Prévia da publicação',
    SCHEDULED_PREVIEW_CREATION_DATE: 'Criação: {{date}}',
    SCHEDULED_PREVIEW_SCHEDULED_DATE: 'Agendado: {{date}}',
    SCHEDULED_PREVIEW_ONLY_PREVIEW_TEXT: 'Há menos de um minuto',
    SCHEDULED_PREVIEW_SHOW_MORE: 'Ver mais',
    SCHEDULED_PREVIEW_SHOW_LESS: 'Ver menos',
  },
};
